import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import strings from "./utils/strings";
import { useDispatch } from "react-redux";
import { setLoading } from "./modules/loading/loadingSlice";

const PrivateRoute = ({ element: Component, ...rest }) => {
  const dispatch = useDispatch()
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

  console.log("private");

  if (inProgress !== "none") {
    return <Component {...rest} /> ;
  }

  return isAuthenticated ? <Component {...rest} /> : <Navigate to={strings.navigation.welcome} state={{ from: location }} replace />;
};

export default PrivateRoute;
